export const gallery = [
  {
    image: '/launchpad/stories/metropolis/app-1.png',
  },
  {
    image: '/launchpad/stories/metropolis/app-2.png',
  },
];
